import { Bootstraper } from '../bootstraper';
import { ApplicationSidenav } from './application-sidenav';
import { FullImage } from './full-screen-image';

export class ProductPage {
    
    private applicationSidenav: ApplicationSidenav;
    private fullImage: FullImage;
    
    constructor() {        
        this.applicationSidenav = new ApplicationSidenav();
        this.fullImage = new FullImage('productImage');

        this.setLinkToApps();
    }

    private setLinkToApps(): void {
        const appLinks = document.querySelectorAll('.content-table__row_app');
        const currentUrl = new URL(window.location.href);
        appLinks.forEach(link => {
            link.addEventListener('click', () => {
                const id = link.getAttribute('id');             
                const newUrl = `${currentUrl.pathname}?code=${currentUrl.searchParams.get('code')}&appid=${id}#catalog`;
                history.pushState(newUrl, '', newUrl);
                this.applicationSidenav.checkOpenSidenav();
            });
        });
    }
}

Bootstraper.bootsrtapOnWindowLoaded(ProductPage);
